import { useCallback, useState } from 'react';

export const useImageDownloader = () => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadImages = useCallback(async (imageUrls: string[]) => {
    setIsLoading(true);

    for (const url of imageUrls) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = url.split('/').pop()?.split('?')[0] || 'image.jpg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error(`Error downloading ${url}:`, error);
      }
    }

    setIsLoading(false);
  }, []);

  return { isLoading, downloadImages };
};
